<div class="modal-header">
    <button type="button" class="close" aria-hidden="true" (click)="close()">x</button>
    <h3 class="modal-title">Export Dashboard</h3>
</div>
<div class="modal-body">
    <!-- <pre>{{newUser | json}}</pre> -->
    <div class="row">
        <div class="col-md-7">
            <div class="form-group label-floating">
                <input id="scoringExport" type="checkbox" [(ngModel)]="selection.enableCbxScoring" (change) = "checkAll(selection)" />
                <label for="scoringExport" class="control-label">Scoring</label>
            </div>
            <div class="form-group label-floating">
                <input id = "utilizationExport" type="checkbox" [(ngModel)]="selection.enableCbxUtil" (change) = "checkAll(selection)" />
                <label for="utilizationExport" class="control-label">Utilization</label>
            </div>
            <div class="form-group label-floating">
                <input id = "radiusGaragingExport" type="checkbox" [(ngModel)]="selection.enableCbxRadiusAddr" (change) = "checkAll(selection)" />
                <label for="radiusGaragingExport" class="control-label">Radius & Garaging</label>
            </div>
            <div class="form-group label-floating">
                <input id = "territoryExport" type="checkbox" [(ngModel)]="selection.enableCbxTerritory" (change) = "checkAll(selection)" />
                <label for="territoryExport" class="control-label">Territory</label>
            </div>
            <div class="form-group label-floating">
                <input id= "speedingExport" type="checkbox" [(ngModel)]="selection.enableCbxSpeeding" (change) = "checkAll(selection)" />
                <label for="speedingExport" class="control-label">Speeding</label>
            </div>
            <div class="form-group label-floating">
                <input id = "harhEventExport"type="checkbox" [(ngModel)]="selection.enableCbxHarshEvent" (change) = "checkAll(selection)" />
                <label for="harhEventExport" class="control-label">Harsh Event</label>
            </div>
            <div class="form-group label-floating">
                <input id = "safetyEventExport" type="checkbox" [(ngModel)]="selection.enableCbxSafetyEvent" (change) = "checkAll(selection)" />
                <label for="safetyEventExport" class="control-label">Safety Event</label>
            </div>
            <!-- <div class="form-group label-floating">
                <input type="checkbox" ng-model="selection.enableCbxDriverScoreCard" ng-init ="selection.enableCbxDriverScoreCard = true" ng-change = "checkAll(selection)" />
                <label for="i4" class="control-label">Driver Score Card</label>
             </div> -->
            <div class="form-group label-floating">
                <input id = "allExport" type="checkbox" [(ngModel)]="selection.enableCbxAll" (change) = "checkAll(selection, selection.enableCbxAll)" />
                <label for="allExport" class="control-label">ALL</label>
            </div>
        </div>
       
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-warning" type="button" (click)="close()">Cancel</button>
    <button class="btn btn-info" type="button" (click)="export()">Export</button>
</div>
